var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAjuda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#000E4B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.168 0 0 7.168 0 16C0 24.832 7.168 32 16 32C24.832 32 32 24.832 32 16C32 7.168 24.832 0 16 0ZM17.6 27.2H14.4V24H17.6V27.2ZM20.912 14.8L19.472 16.272C18.32 17.44 17.6 18.4 17.6 20.8H14.4V20C14.4 18.24 15.12 16.64 16.272 15.472L18.256 13.456C18.848 12.88 19.2 12.08 19.2 11.2C19.2 9.44 17.76 8 16 8C14.24 8 12.8 9.44 12.8 11.2H9.6C9.6 7.664 12.464 4.8 16 4.8C19.536 4.8 22.4 7.664 22.4 11.2C22.4 12.608 21.824 13.888 20.912 14.8Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAjuda);
export default __webpack_public_path__ + "static/media/ajuda.66f6aac3130ece8df7afc1e1744ee78c.svg";
export { ForwardRef as ReactComponent };